import React from 'react';
import {Navigate, Route} from 'react-router-dom';
import {PARAMS_ENTITY, routes, routesPrefix} from "./routes/enums";
import EntityListPage from "@/modules/EntityList";
import EntityDetailPage from "@/modules/Entity";
import {MAP_TIPOS_ENTITY_CONFIG} from "@/config/globalEntityFrontEndConfig";
import {sendEvent} from "@/analytics/analitycs";
import {ELEMENTS, TIPOS_EVENTOS} from "@/analytics/config/analyticsParamsFrontEnd";
import * as Sentry from "@sentry/react";

const tipos_regexp = Object.keys(MAP_TIPOS_ENTITY_CONFIG).filter(e => e !== "default").join("|")
let root_buscar_pet_friendly_regexp = "^/?buscar-pet-friendly"
let root_detail_entity_regexp = "^/?pet-friendly"
let tipo_regexp = "(/(" + tipos_regexp + ")s)"
let tipo_entity_detail_regex = "(/(" + tipos_regexp + "))"
let provincia_regexp = "(/en-[a-zA-ZÀ-ÿ\\u00f1\\u00d1-]*)"


export function renderRoutesEntities(props) {
    return (
        <>
            <Route path={routesPrefix.rootBuscador} /*element={<DefaultLayout/>}*/>
                <Route index element={<EntityListPage/>}/>
                {createRoutesBuscadorEntities()}
                <Route exact path={routes.buscadorProvinciaMun} element={<EntityListPage/>}/>
                <Route exact path={routes.buscadorPagina} element={<EntityListPage/>}/>
                <Route path='*' element={<Navigate to={routesPrefix.rootBuscador}/>}/>
            </Route>
            <Route path={routesPrefix.rootEntity} /*element={<DefaultLayout/>}*/>
                <Route index element={<Navigate to={routesPrefix.rootBuscador}/>}/>
                <Route exact path={routes.entityPermalink} element={<EntityDetailPage/>}/>
                <Route path='*' element={<Navigate to={routesPrefix.rootBuscador}/>}/>
            </Route>
        </>
    );
}

const createRoutesBuscadorEntities = () => {
    return Object.keys(MAP_TIPOS_ENTITY_CONFIG).filter(k => k !== "default")
        .map(t => routes.buscador.replace(PARAMS_ENTITY.tipo.name, t))
        .map((path) => <Route key={path} path={path} element={<EntityListPage/>}/>);
}

export function onChangeLocation(location) {
    try {
        if (new RegExp(root_detail_entity_regexp + tipo_entity_detail_regex + "/").test(location.pathname)){
            const permalink = location.pathname.replace(new RegExp(root_buscar_pet_friendly_regexp + tipo_entity_detail_regex + "?"), "")?.split("?")[0]
            // console.log("Entity permalink = '" + permalink + "'");
            sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.ENTITY.ENTITY, {permalink})
        } else if (new RegExp(root_buscar_pet_friendly_regexp + tipo_regexp + "?", "gmi").test(location.pathname) ||
            new RegExp(root_buscar_pet_friendly_regexp + provincia_regexp + "?", "gmi").test(location.pathname)){
            // console.log("Buscador permalink = '" + location.pathname + "'");
            sendEvent(TIPOS_EVENTOS.PAGEVIEW, ELEMENTS.BUSCADOR_PETFRIENDLY.BUSCADOR, {permalink: location.pathname})

        }
    } catch (e) {
        Sentry.captureException(e);
    }
}

